export default __webpack_public_path__ + "static/media/Howitworks2.6ba567cc.png";